import PropTypes from "prop-types";
import parse from "html-react-parser";
import Frame from "react-frame-component";

Desktop.propTypes = {
  text: PropTypes.string
};

export default function Desktop({ text }) {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 960,
        borderRadius: 24,
        backgroundColor: "#eee",
        padding: "56px 8px",
        marginTop: 1
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          border: "1px solid black",
          height: 480
        }}
      >
        <Frame width="100%" height="100%">{parse(text)}</Frame>
      </div>
    </div>
  );
}
